import React, { useState } from "react";
import { Link } from "react-router-dom";

function Reporting() {
  const [reportingData] = useState([
    {
      name: "Daily Sale Report",
      path: "dailySaleReport",
    },
    {
      name: "Detailed Sale Report",
      path: "detailedSaleReport",
    },
    {
      name: "Detailed Shift Report",
      path: "detailedShiftReport",
    },
  ]);

  const [businessReport] = useState([
    {
      name: "Vat Report",
      path: "vatReport",
    },
    {
      name: "Multiple Vat Report",
      path: "multipleVatReport",
    },
    {
      name: "Overall report",
      path: "overallReport",
    },
    {
      name: "Daily Summary Report",
      path: "dailySummaryReport",
    },
    {
      name: "Profit Loss Report",
      path: "profileLossReport",
    },
    {
      name: "Kitchen Performance Report",
      path: "kitchenPerformanceReport",
    },
  ]);

  const [payableReport] = useState([
    {
      name: "Expense Report",
      path: "expensesReport",
    },
    {
      name: "Return Report",
      path: "returnReport",
    },
    {
      name: "Loyalty Points Report",
      path: "loyaltyPointReport",
    },
    {
      name: "Purchase Report",
      path: "purchaseReport",
    },
    {
      name: "Detailed Purchase Report",
      path: "detailPurchaseReport",
    },
    {
      name: "Customer Due Report",
      path: "customerDueReport",
    },
    {
      name: "Supplier Ledger",
      path: "supplierLedgerReport",
    },

    {
      name: "Customer Ledger",
      path: "customerLedger",
    },

    {
      name: "Supplier Due Report",
      path: "supplierDueReport",
    },
  ]);

  const [activityReport] = useState([
    {
      name: "Register Report",
      path: "registerReport",
    },
    {
      name: "Rider Report",
      path: "riderReport",
    },
    {
      name: "Vendor report",
      path: "vendorReport",
    },
    {
      name: "Food Sale Report",
      path: "foodSalesReport",
    },
    {
      name: "Waste Report",
      path: "wasteReport",
    },
    {
      name: "Attendance Report",
      path: "attendanceReport",
    },
    {
      name: "Low Inventory Report",
      path: "lowInventoryReport",
    },

    {
      name: "Consumption Report",
      path: "consumptionReport",
    },

    {
      name: "Inventory Report",
      path: "inventoryReport",
    },
  ]);

  return (
    <main className="my-16">
      <div>
        <h1 className="text-[#7B20C7] text-2xl font-medium pt-4">Reporting</h1>
      </div>
      <div className="relative my-8 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex flex-col lg:flex-row gap-y-2 w-full py-3">
          <div className="w-full lg:w-1/3">
            <h1 className=" text-[#7B20C7] text-lg">Sales</h1>
            {reportingData &&
              reportingData.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-[#7B20C7]">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>

          <div className="w-full lg:w-1/3">
            <h1 className=" text-[#7B20C7] text-lg">
              Business Overview
            </h1>
            {businessReport &&
              businessReport.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-[#7B20C7]">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>

          <div className="w-full lg:w-1/3">
            <h1 className=" text-[#7B20C7] text-lg">
              Payables and Receivables
            </h1>
            {payableReport &&
              payableReport.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-[#7B20C7]">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>

          <div className="w-full lg:w-1/3">
            <h1 className=" text-[#7B20C7] text-lg">Activity</h1>
            {activityReport &&
              activityReport.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-[#7B20C7]">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </main>
  );
}
export default Reporting;
